module.exports = __webpack_public_path__ + "img/2-3.dcec0320.svg";